import { LAST_SEEN_PRODUCT_RELEASE_SAVE_ASYNC } from './constants'

export const saveLastSeenProductRelease = () => ({
  type: LAST_SEEN_PRODUCT_RELEASE_SAVE_ASYNC.INITIATE,
})
export const saveLastSeenProductReleaseSuccess = () => ({
  type: LAST_SEEN_PRODUCT_RELEASE_SAVE_ASYNC.SUCCESS,
})
export const saveLastSeenProductReleaseError = (error) => ({
  type: LAST_SEEN_PRODUCT_RELEASE_SAVE_ASYNC.ERROR,
  error,
})

export default {
  // to props
  saveLastSeenProductRelease,
  saveLastSeenProductReleaseSuccess,
}
